<template>
  <div class="aside-container">
    <el-row>
      <el-col :span="24">
        <el-menu
          default-active="2"
          text-color="#606266"
          active-text-color="#D04247"
          router
          @select="clickAsideNav"
        >
          <div v-for="menu in asideTabMenu" :key="menu.id">
            <el-menu-item :index="menu.path" v-if="!menu.children">
              {{ menu.title }}
            </el-menu-item>
            <el-submenu :index="menu.path" v-else>
              <template slot="title">{{ menu.title }}</template>
              <div v-for="menuChidren in menu.children" :key="menuChidren.id">
                <el-menu-item
                  :index="menuChidren.path"
                  v-if="!menuChidren.children"
                >
                  {{ menuChidren.title }}
                </el-menu-item>
                <el-submenu :index="menuChidren.path" v-if="menuChidren.list">
                  <template slot="title">{{ menuChidren.title }}</template>
                  <el-menu-item
                    :index="menuChidrenItem.path"
                    v-for="menuChidrenItem in menuChidren.children"
                    :key="menuChidrenItem.id"
                  >
                    {{ menuChidrenItem.title }}
                  </el-menu-item>
                </el-submenu>
              </div>
            </el-submenu>
          </div>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'NavAside',
  methods: {
    ...mapMutations('m_tabs', ['changeRoutePath']),
    clickAsideNav(index) {
      this.changeRoutePath(index)
      console.log(index);

    }
  },
  computed: {
    ...mapState('m_tabs', ['asideTabMenu'])
  },
}
</script>

<style lang="scss" scoped>
.aside-container {
  height: 100vh;
}
</style>
